import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { AuthService } from "../auth.service";

declare var $: any;

@Injectable()
export class UtilsRolesService {
  constructor(private router: Router) {}

  isAdminUser() {
    if (
      localStorage.getItem(environment.storageTypeUserNameApi) ==
      "clientuserNoAdmin"
    ) {
      return false;
    } else if (
      localStorage.getItem(environment.storageTypeUserNameApi) ==
        "clientuser" ||
      localStorage.getItem(environment.storageTypeUserNameApi) == "adminAccess"
    ) {
      return true;
    }
  }

  havePermission(
    component1,
    component2 = null,
    component3 = null,
    component4 = null
  ): boolean {
    let respComp1 = false;
    let respComp2 = false;
    let respComp3 = false;
    let respComp4 = false;
    if (component2 == null) {
      respComp2 = true;
    }

    if (component3 == null) {
      respComp3 = true;
    }

    if (component4 == null) {
      respComp4 = true;
    }

    const rawPermissions = AuthService.getFromStorage(
      environment.storageUserPermissionsNameApi
    );
    const permissions = rawPermissions ? JSON.parse(rawPermissions) : null;

    if (!permissions || typeof permissions !== "object") {
      return false;
    }

    const keys = Object.keys(permissions);

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      for (let itemChildrenRoute of permissions[key]) {
        // console.log(itemChildrenRoute);
        if (component1 == itemChildrenRoute) {
          respComp1 = true;
        }
        if (component2 != null) {
          if (component2 == itemChildrenRoute) {
            respComp2 = true;
          }
        }
        if (component3 != null) {
          if (component3 == itemChildrenRoute) {
            respComp3 = true;
          }
        }
        if (component4 != null) {
          if (component4 == itemChildrenRoute) {
            respComp4 = true;
          }
        }
      }
    }
    if (respComp1 && respComp2 && respComp3 && respComp4) {
      return true;
    } else {
      return false;
    }
  }
}
